// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const charizard_gmax: PokeData = {
  "id": 10196,
  "name": "charizard-gmax",
  "height": 280,
  "weight": 10000,
  "base_experience": 240,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [],
  "moves": [
    "peck",
    "fire-spin",
    "roost",
    "fire-punch",
    "brave-bird",
    "magma-storm",
    "air-slash",
    "blaze-kick",
    "ember",
    "morning-sun",
    "sunny-day",
    "gust",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 2,
    "item": null,
    "species": [
      {
        "name": "charmander",
        "order": 4,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "charmeleon",
        "order": 5,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 4,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "charizard",
        "order": 6,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 5,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 139,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
